import { Pipe, PipeTransform } from '@angular/core';
import { FinancialChurnType } from '../../interfaces/dashboard';

@Pipe({
  name: 'financialChurnType'
})
export class FinancialChurnTypePipe implements PipeTransform {

  transform(value: FinancialChurnType): string {
    const types = {
      [FinancialChurnType.BETS]: 'Aposta',
      [FinancialChurnType.CHARGE]: 'Depósitos'
    }

    return types[value]
  }

}
